<style>

textarea{
  background-color: inherit;
  border: 0;
  border-radius: 0;
  /* border: 1px #222 solid; */
  border-bottom: 2px white solid;
  color: white;
  /* background-color: rgba(255,255,255,0.2); */
  background-image: linear-gradient(to bottom, rgba(255,255,255,0.1), rgba(255,255,255,0));
  height: 220px;
}

h3{
  text-align: center;
}

.space{
  margin: 20px;
}

/* .optional{
  text-align: center;
  color: white;
  font-size: 16px;
} */

.chars-left{
  font-size: 16px;
  margin: 0 10px 0 10px;
  color: white;
}

</style>

<Auth bind:this="{auth}"></Auth>
<Profile bind:this="{profile}" bind:me="{me}"></Profile>

{#if show}

<h3>Write a quick bio about yourself</h3>
<!-- <div class="optional">(Optional)</div> -->
<div class="margin">
  <textarea bind:value="{bio}" placeholder="Your bio" on:keyup="{check}"></textarea>
</div>
<div class="chars-left">{bioLen} Characters Left</div>

{/if}


<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

import Auth from "../../interfaces/Auth.svelte";
let auth;

import Profile from "../../interfaces/Profile.svelte";
let profile;

import Validate from "../../helpers/Validate.js";
import Normalize from "../../helpers/Normalize.js";

export let show = false;
export let me = null;

let allowSignup = false;
let bio = "";
let bioSaved = false;
let nextDisabled = true;

let bioLen = 1000;

$:{
  if (me) set();
}


function set() {
  bio = me.bio;
  bioLen = 1000 - bio.length;
}


function check() {
  // bioSaved = false;
  bioLen = 1000 - bio.length;
  try {
    Validate.bio(bio);
  } catch (e) {
    console.log("error:", e);
  }
}


export const save = async () => {
  if (bio != me.bio) {
    me.bio = bio;
    await profile.updateMe( { updateShare: true } );
  }
}

</script>